import data from './map-data';
import customEventPolyfill from 'custom-event-polyfill'; // Custom Event IE

export default{
    map: 'uk_regions_merc' ,
    zoomMin: 3,
    backgroundColor: '#333',
    zoomOnScroll : false,
    onRegionClick : function(e , code){
        // Fire an event so teh app can listen to it
        let event = new CustomEvent("click-uk-map", { "detail": {e , code} });
        document.dispatchEvent(event);
    },  
    regionStyle: {
        initial: {
          fill: '#128da7'
        },
        hover: {
            fill: "#c8102e"
          }
    },
    onRegionTipShow: function(e, el, code){
        e.preventDefault();
    },
    onTipShow: function(e, label, code) {
        e.preventDefault();
    },
    labels: {
        regions: {
            render: function(code){
            // var doNotShow = ['US-RI', 'US-DC', 'US-DE', 'US-MD'];

            // if (doNotShow.indexOf(code) === -1) {
            //     return code.split('-')[1];
            // }
            //console.log(data.paths[code].name);
            return data.paths[code].name;//.split('-')[1];    
            },
            offsets: function(code){
                // X:Y coordinates
                return {
                    'SCT': [60, 120],// Scotland
                    'UKI': [0, 0], // London
                    'UKD': [-45,-40], // North West
                    'UKC': [25, 5], // North East,
                    'UKE': [120, -10], // Yorkshire,
                    'UKF' : [40 , -35], //East midlands
                    'UKJ' : [7 , 30], // South East
                    'UKK' : [45 , 5], // Soth West
                    'WLS' : [5, 35] // Wales
                }[code];
            }
        }
    },
    regionLabelStyle : {
        initial: {
            'font-family': 'Verdana',
            'font-size': '12',
            'font-weight': 'bold',
            cursor: 'default',
            fill: 'white',
            background: 'black'
        },
        hover: {
            cursor: 'pointer',
            //fill: 'red'
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/data/map-settings.js